var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    ..._vm.containerStyle,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  })},[_c('div',{style:({
      ..._vm.containerBgStyle,
      position: 'absolute',
      zIndex: 0,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundPositionX: 'center',
    })}),(_vm.isShowFloatTop)?_c('FloatTop',{attrs:{"pageName":"MicrositeMenu","campaign":_vm.campaign,"isShowRedirectHome":_vm.isShowFloatTop}}):_vm._e(),_c('FloatBottom',{attrs:{"pageName":"MicrositeMenu","campaign":_vm.campaign}}),(_vm.survey)?_c('Survey',{staticStyle:{"height":"fit-content","z-index":"1"},style:({
      paddingTop: _vm.isShowFloatTop ? '52px' : '0px',
    }),attrs:{"survey":_vm.survey}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }